import { defineComponent } from "vue";
import { brightenKeyword } from "@/hooks/lightKeyword";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "SAlbum",
  props: {
    albumList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    inputValue: {
      type: String,
      default: ""
    }
  },
  setup: function setup() {
    var router = useRouter();
    /* 关键字高亮 */

    var lightKeyword = brightenKeyword;
    /* 专辑点击事件 */

    var albumClick = function albumClick(id) {
      router.push("/main/albumdetail/".concat(id));
    };

    return {
      lightKeyword: lightKeyword,
      albumClick: albumClick
    };
  },
  components: {}
});